//--------------------------------------- Official-server --------------------------------------------
const OFFICIAL_URLS = {
    AUTH_URL: "https://api.milanese.am/auth/api/v1",
    ADMIN_URL: "https://api.milanese.am/admin/api/v1",
    MEDIA_URL: "https://api.milanese.am/file/api/v1",
    HOST_MEDIA_URL: "https://api.milanese.am/file",
}

//--------------------------------------- 4Steps-server --------------------------------------------

const TESTING_URLS = {
    AUTH_URL: "http://173.212.233.220:3200/api/v1",
    ADMIN_URL: "http://173.212.233.220:3201/api/v1",
    MEDIA_URL: "http://173.212.233.220:3203/api/v1",
    HOST_MEDIA_URL: "http://173.212.233.220:3203",
}
const { AUTH_URL, USER_URL, ADMIN_URL, MEDIA_URL, SOCKET_URL, HOST_MEDIA_URL, } =
     OFFICIAL_URLS
     // TESTING_URLS;

export const _urlOauth = AUTH_URL ;
export const _urlMedia = MEDIA_URL + "/file";
export const _urlLanguages = ADMIN_URL + "/language";
export const _urlReviews = ADMIN_URL + "/reviews";
export const _urlUsers = ADMIN_URL + "/users";
export const _urlRegion = USER_URL + "/regions";
export const _urlOthers = ADMIN_URL + "/others";
export const _urlContact = ADMIN_URL + "/contact";
export const _urlBadges = ADMIN_URL + "/badge";
export const _urlPartner = ADMIN_URL + "/partner";
export const _urlPartnerRequest = ADMIN_URL + "/join-us";
export const _urlStatus = ADMIN_URL + "/order-statuses";
export const _urlNotif = ADMIN_URL + "/notifications";
export const _urlModerator = ADMIN_URL + "/moderator";
export const _urlStaticTexts = ADMIN_URL + "/static-texts";
export const _urlFilters = ADMIN_URL + "/filter";
export const _urlAttributes = ADMIN_URL + "/attributes";
export const _urlCategories = ADMIN_URL + "/category";
export const _urlSlider = ADMIN_URL + "/slider";
export const _urlProject = ADMIN_URL + "/project";
export const _urlBanner = ADMIN_URL + "/banners";
export const _urlMarket = ADMIN_URL + "/markets";
export const _urlSection = ADMIN_URL + "/sections";
export const _urlProducts = ADMIN_URL + "/product";
export const _urlOrders = ADMIN_URL + "/orders";
export const _urlPromoCodes = ADMIN_URL + "/promo-codes";
export const _urlBonusCards = ADMIN_URL + "/bonus-cards";
export const _urlCustomPages = ADMIN_URL + "/custom-pages";
export const _urlAbout = ADMIN_URL + "/about";
export const _urlBlogTypes = ADMIN_URL + "/blog-types";
export const _urlBlogs = ADMIN_URL + "/blog";
export const _urlRequest = ADMIN_URL + "/request";
export const _urlSubscribe = ADMIN_URL + "/subscriber";
export const _urlAdvertising = ADMIN_URL + "/advertising";
export const _urlBrandTypes = ADMIN_URL + "/brand-type";
export const _urlBrands = ADMIN_URL + "/brand";

export const _urlSocket = SOCKET_URL;
export const _hostMedia = HOST_MEDIA_URL;

